module.exports = __webpack_public_path__ + "9fe126fd1350951aad9a6e48d33afa5a.pdf";